import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['modal'];
  declare modalTarget: HTMLElement;

  remove() {
    this.modalTarget.hidden = true;
    const origin = window.location.origin;
    const path = window.location.pathname;
    window.location.href = origin + path + '?revision=';
  }
}
